import { restApiActions } from 'redux/redux-actions';

export default restApiActions('transactions');
